import "./BarSpinner.css";

interface BarSpinnerProps {
  className?: string;
}

const BarSpinner = ({ className }: BarSpinnerProps) => (
  <div className={`bar-spinner ${className || ""}`}>
    {Array.from({ length: 12 }).map((_, i) => (
      <div className="bar-spinner-bar" key={i} />
    ))}
  </div>
);

export default BarSpinner;
